import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white border-t-2 border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">CricketBet Pro</h3>
            <p className="text-gray-400">
              Your trusted platform for cricket betting and match predictions.
            </p>
            <div className="mt-4 text-sm text-gray-400">
              <p>Licensed & Regulated</p>
              <p>18+ Only | Gamble Responsibly</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/live-betting"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Live Betting
                </Link>
              </li>
              <li>
                <Link
                  to="/matches"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Upcoming Matches
                </Link>
              </li>
              <li>
                <Link
                  to="/my-bets"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  My Bets
                </Link>
              </li>
              <li>
                <Link
                  to="/predictions"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Expert Predictions
                </Link>
              </li>
              <li>
                <Link
                  to="/responsible-gambling"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Responsible Gambling
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">24/7 Support</h3>
            <div className="text-gray-400 space-y-2">
              <p>Email: support@cricketbet.com</p>
              <p>Helpline: 1-800-CRICKET</p>
              <p>Live Chat Available 24/7</p>
            </div>
            <div className="mt-4">
              <p className="text-sm text-yellow-500">
                Problem with gambling? Get help now
              </p>
              <p className="text-sm text-gray-400">
                Gambling Helpline: 1-800-522-4700
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} CricketBet Pro. All rights reserved.
              <span className="block md:inline mt-2 md:mt-0 md:ml-4">
                <Link to="/terms" className="hover:text-white">
                  Terms & Conditions
                </Link>{" "}
                |{" "}
                <Link to="/privacy" className="hover:text-white">
                  Privacy Policy
                </Link>{" "}
                |{" "}
                <Link to="/betting-rules" className="hover:text-white">
                  Betting Rules
                </Link>
              </span>
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="#" className="text-gray-400 hover:text-white">
                <span className="sr-only">Facebook</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </Link>
              <Link to="#" className="text-gray-400 hover:text-white">
                <span className="sr-only">Twitter</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                </svg>
              </Link>
              <Link to="#" className="text-gray-400 hover:text-white">
                <span className="sr-only">Instagram</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
